import React from 'react';
import { Mail, RefreshCw, Plus, Clock, Tag } from 'lucide-react';

interface MailHeaderProps {
    unreadCount: number;
    selectedKeyword?: string;
    filteredCount: number;
    onRefresh: () => void;
    onAddKeyword: () => void;
}

const MailHeader: React.FC<MailHeaderProps> = ({
    unreadCount,
    selectedKeyword,
    filteredCount,
    onRefresh,
    onAddKeyword
}) => {
    return (
        <div className="bg-white border-b border-gray-200 px-6 py-4">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
                <div className="flex items-center space-x-4">
                    <div className="flex items-center">
                        <div className="p-2 bg-blue-100 rounded-lg mr-3">
                            <Mail className="h-6 w-6 text-blue-600" />
                        </div>
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900">Mail Takibi</h1>
                            <p className="text-sm text-gray-600">Email hesaplarınızı izleyin ve kategorileyin</p>
                        </div>
                    </div>

                    <div className="hidden sm:flex items-center space-x-2">
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium flex items-center">
                            <Clock className="h-3 w-3 mr-1" />
                            {unreadCount} yeni
                        </span>
                        {selectedKeyword && (
                            <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium flex items-center">
                                <Tag className="h-3 w-3 mr-1" />
                                "{selectedKeyword}": {filteredCount}
                            </span>
                        )}
                    </div>
                </div>

                <div className="flex items-center space-x-2">
                    <button
                        onClick={onRefresh}
                        className="flex items-center px-3 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors text-sm font-medium"
                    >
                        <RefreshCw className="h-4 w-4 mr-2" />
                        Yenile
                    </button>
                    <button
                        onClick={onAddKeyword}
                        className="flex items-center px-3 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-lg transition-colors text-sm font-medium"
                    >
                        <Plus className="h-4 w-4 mr-2" />
                        Keyword Ekle
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MailHeader;
